import * as React from 'react';
import { Plan } from './components/Plan';
import { PlanNotAvailable } from './components/PlanNotAvailable';
import { PlanNotAccurate } from './components/PlanNotAccurate';
import { jsx as _jsx } from "react/jsx-runtime";
export var FloorPlanContainer = function FloorPlanContainer(_ref) {
  var hoveredFlatPlanId = _ref.hoveredFlatPlanId,
    flats = _ref.flats,
    floorPlanUrl = _ref.floorPlanUrl,
    flatsCount = _ref.flatsCount,
    isPlanAccurate = _ref.isPlanAccurate,
    isError = _ref.isError,
    isLoading = _ref.isLoading,
    onFlatOpen = _ref.onFlatOpen,
    onFlatHover = _ref.onFlatHover;
  var isPlanNotAvailable = isError || !floorPlanUrl;
  var isRoomTypeNotAvailable = flatsCount === 0;
  var isFloorPlanNotDefined = isPlanNotAvailable || isRoomTypeNotAvailable;
  if (isFloorPlanNotDefined && isLoading) {
    return null;
  }
  if (isPlanNotAvailable) {
    return /*#__PURE__*/_jsx(PlanNotAvailable, {});
  }

  //TODO: Добавить заглушку в следующей итерации
  // if (isRoomTypeNotAvailable) {
  //   return <RoomTypeNotAvailable />;
  // }

  if (!isPlanAccurate) {
    return /*#__PURE__*/_jsx(PlanNotAccurate, {
      floorPlanUrl: floorPlanUrl
    });
  }
  return /*#__PURE__*/_jsx(Plan, {
    hoveredFlatPlanId: hoveredFlatPlanId,
    floorPlanUrl: floorPlanUrl,
    onFlatOpen: onFlatOpen,
    onFlatHover: onFlatHover,
    flats: flats
  });
};